/* eslint-disable no-unused-vars */
export default class IHTTPClientAdapter {
  constructor() {
    if (this.constructor == IHTTPClientAdapter) {
      throw new Error("Abstract classes can't be instantiated.");
    }
  }
  async get(url, config) {}
  async post(url, body, headers) {}
  async delete(url, headers) {}
}

